import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Answer, FileAnswer } from 'src/app/models/Answer.model';
import { AnswersStore } from 'src/app/store/answers-store';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
// import { DragDirective } from '../../../../drag.directive';
import { debounceTime, map } from 'rxjs';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { UploadFileLocalDisplayComponent } from "./upload-file-local-display/upload-file-local-display.component";

@Component({
    selector: 'que-upload-file-display',
    imports: [CommonModule, ReactiveFormsModule, TranslateDirective, TranslatePipe, UploadFileLocalDisplayComponent],
    templateUrl: './upload-file-display.component.html',
    styleUrls: ['./upload-file-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadFileDisplayComponent {
  @Input() question?: Question;
  @Input() isDisplay?: boolean;
  @Input() viewAnswer = false;

  answer = new FormControl<FileAnswer[]>([]);
  selectedFileName: string | null = null;
  #answerStore = inject(AnswersStore);
  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));
  isUser: boolean = false;
  isMulty: boolean = false;

  ngOnInit(): void {
    this.isMulty = this.question?.definitions?.allowMultipleFiles ?? false;
    this.answer.setValidators(this.question?.requierd ? [Validators.required] : null);


    this.answer.valueChanges.pipe(debounceTime(50)).subscribe(
      ans => {
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, files: ans || [], isValid: this.answer.valid })
      });

    this.#answerStore.answers$
      .pipe(
        map(arr => arr.find(ans => ans.questionId === this.question?.id)),
      )
      .subscribe(x => {
        if (x) {
          this.answer.setValue(x.files || [], { emitEvent: false });
        }
      }).unsubscribe();


    this.isNotUser$.subscribe((isNotUser) => {
      if (isNotUser) {
        this.isUser = false;
      } else {
        this.isUser = true;
      }
    });
  }
}
